import PayRollListContainer from './PayrollListContainer'

const PayRollList = () => <PayRollListContainer/>

export default PayRollList
